module.exports = __webpack_public_path__ + "f32abd25f2228481b4dbe0101bf2a49a.jpg";